module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-134.723e3aa.woff2";